import React, {useCallback} from "react";
import {useSearchParams} from "react-router-dom";
import {captureItemsMolliePayment} from "../api/apiClient";
import {useCartContext} from "../contexts/CartContext";
import {usePaymentStatusPolling} from "../hooks/usePaymentStatusPolling";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const DEFAULT_ERROR_MESSAGE = "Die gewünschten Artikel wurden nicht gekauft.";

const ShopMollieCallbackPage = () => {
    const [searchParams] = useSearchParams();
    const {clearCart} = useCartContext();

    // Mollie does not append anything to the return URL, so the backend puts its own token there.
    const token = searchParams.get("token");

    const onSuccess = useCallback(() => {
        clearCart();
        trackEvent('Purchase', {currency: 'EUR'});
    }, [clearCart]);

    const {paymentStatus, errorMessage} = usePaymentStatusPolling(captureItemsMolliePayment, token, onSuccess);

    return (
        <PaymentConfirmation
            paymentStatus={paymentStatus}
            paymentProvider="Pay by Bank"
            backTo="/shop"
            backLabel="ZURÜCK ZUM SHOP"
            generalErrorMessage={errorMessage || DEFAULT_ERROR_MESSAGE}
        />
    );
};

export default ShopMollieCallbackPage;
